<mat-card class="card-pass">
  <mat-card-content>
    @if (passenger.type=='ADULT') {
      <div class="pass-title">Passeggero {{index+1}}: Adulto</div>
    }
    @if (passenger.type=='CHILDREN') {
      <div class="pass-title">Passeggero {{index+1}}: Ragazzo</div>
    }
    <div class="fx-row fx-wrap" style="gap: 3px">
      <div class="fx-flex">
        <form-input-viewer
          [readOnly]="isReadOnly"
          [formInputDefinition]='fields.get("pass_first_name")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["pass_first_name"]'
        ></form-input-viewer>
      </div>

      <div class="fx-flex">
        <form-input-viewer
          [readOnly]="isReadOnly"
          [formInputDefinition]='fields.get("pass_last_name")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["pass_last_name"]'
        ></form-input-viewer>
      </div>
      <div class="fx-flex">
        <form-input-viewer
          [formInputDefinition]='fields.get("pass_data_n")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["pass_data_n"]'
        ></form-input-viewer>
      </div>

    </div>
    <div class="fx-row fx-wrap" style="gap: 3px">
      <div class="fx-flex">
        <form-input-viewer
          [readOnly]="isReadOnly"
          [formInputDefinition]='fields.get("pass_email")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["pass_email"]'
        ></form-input-viewer>
      </div>
      <div class="fx-flex">
        <form-input-viewer
          [readOnly]="isReadOnly"
          [formInputDefinition]='fields.get("pass_phone")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["pass_phone"]'
        ></form-input-viewer>
      </div>
      <div class="fx-flex">
        <form-input-viewer
          [formInputDefinition]='fields.get("pass_cf")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["pass_cf"]'
        ></form-input-viewer>
      </div>
    </div>
    @if (canApplyDiscount) {
      <div class="fx-row fx-wrap">
        <button mat-button color="accent" type="button" (click)="toggleDiscountCode()">
          <mat-icon>{{showDiscountCode ? 'expand_less' : 'local_offer'}}</mat-icon>
          {{'Inserisci buono sconto' | translate}}
        </button>
      </div>
      @if (showDiscountCode) {
        <div class="fx-row fx-wrap discount-code-row" style="gap: 3px">
          <div class="fx-flex">
            <div class="fx-row discount-code-field">
              <div class="fx-flex">
                <form-input-viewer
                  [formInputDefinition]='fields.get("pass_discount_code_fw")'
                  [formGroup]='formViewerService.formGroup'
                  [formControlKey]='formViewerService.controlKeyMap["pass_discount_code_fw"]'
                ></form-input-viewer>
              </div>
              <button mat-stroked-button type="button" class="discount-check-button"
                [disabled]="!!checkingDiscountCode"
                (click)="verifyDiscountCode('pass_discount_code_fw')">
                {{(checkingDiscountCode === 'pass_discount_code_fw' ? 'Verifica in corso...' : 'Verifica codice') | translate}}
              </button>
            </div>
          </div>
          @if (isRoundTrip) {
            <div class="fx-flex">
              <div class="fx-row discount-code-field">
                <div class="fx-flex">
                  <form-input-viewer
                    [formInputDefinition]='fields.get("pass_discount_code_rt")'
                    [formGroup]='formViewerService.formGroup'
                    [formControlKey]='formViewerService.controlKeyMap["pass_discount_code_rt"]'
                  ></form-input-viewer>
                </div>
                <button mat-stroked-button type="button" class="discount-check-button"
                  [disabled]="!!checkingDiscountCode"
                  (click)="verifyDiscountCode('pass_discount_code_rt')">
                  {{(checkingDiscountCode === 'pass_discount_code_rt' ? 'Verifica in corso...' : 'Verifica codice') | translate}}
                </button>
              </div>
            </div>
          }
          @if (!isRoundTrip) {
            <div class="fx-flex"></div>
          }
        </div>
      }
    }
    <div class="fx-row fx-wrap" style="gap: 3px">
      <form-input-viewer
        [formInputDefinition]='fields.get("contact_consent")'
        [formGroup]='formViewerService.formGroup'
        [formControlKey]='formViewerService.controlKeyMap["contact_consent"]'
      ></form-input-viewer>
    </div>
  </mat-card-content>
</mat-card>